import numeral from "numeral"
import I18n from "i18n-js"

if ('register' in numeral) {
  try {
    numeral.register('locale', 'es', {
      delimiters: {
        thousands: ',',
        decimal: '.'
      },
      abbreviations: {
        thousand: 'mil',
        million: 'millón',
        billion: 'mil millones',
        trillion: 'trillón'
      },
      currency: {
        symbol: 'Rp'
      }
    });
    numeral.register('locale', 'id', {
      delimiters: {
        thousands: '.',
        decimal: ','
      },
      abbreviations: {
        thousand: 'rb',
        million: 'jt',
        billion: 'mil',
        trillion: 'trl'
      },
      currency: {
        symbol: 'Rp'
      }
    });
    numeral.register('locale', 'vi', {
      delimiters: {
        thousands: ',',
        decimal: '.'
      },
      abbreviations: {
        thousand: 'ng',
        million: 'tr',
        billion: 'tỷ',
        trillion: 'ng tỷ'
      },
      currency: {
        symbol: 'Rp'
      }
    });
    numeral.locale(I18n.locale);
  } catch (e) {
    //
  }
}
